<div id="background">
  <div id="cercle1"></div>
  <div id="cercle2"></div>
</div>

<div id="content" class="h-100 d-grid align-content-center">
  <router-outlet></router-outlet>
  <footer class="position-absolute bottom-0 start-50 translate-middle-x mb-3">
    <span class="bg-white rounded-4 py-1 px-3 shadow-sm text-muted small">
      {{ version }}
    </span>
  </footer>
</div>
